document.addEventListener('DOMContentLoaded', function () {
    // Check for the country popup shown status in sessionStorage
    setTimeout(function(){
          if (sessionStorage.getItem('countryPopupShown') !== 'true') {
            if (document.querySelector('.country-specific-popup-us')){
              document.querySelector('.country-specific-popup-us').style.display = 'block';
            }
          }
    }, 1000)

    // Close popup and set countryPopupShown to true in sessionStorage

    document.querySelectorAll('.close-popup-btn').forEach(close=>{
      close.addEventListener('click', function () {

      if (document.querySelector('.country-specific-popup-us')){
        document.querySelector('.country-specific-popup-us').style.display = 'none';
      }
        sessionStorage.setItem('countryPopupShown', 'true');
      });
    });

    // Set countryPopupShown to true and countryRedirect to false in sessionStorage when choosing to stay

    document.querySelectorAll('.no-button').forEach(nobutton=>{
        nobutton.addEventListener('click', function (e) {
        e.preventDefault();
        sessionStorage.setItem('countryPopupShown', 'true');
        sessionStorage.setItem('countryRedirect', 'true');
        window.location.href = document.querySelector(`.no-button`).getAttribute('href');
        // if (document.querySelector('.country-specific-popup-us')){
        //   document.querySelector('.country-specific-popup-us').style.display = 'none';
        // }
      });
    });

    setTimeout(() =>{
          if (sessionStorage.getItem('countryRedirect') === 'true') {
              window.location.href = document.querySelector(`.no-button`).getAttribute('href');
          } else {
              console.log('no redirect');
              if (document.querySelector('.country-specific-popup-us')){
                document.querySelector('.country-specific-popup-us').style.display = 'none';
              }
          }
    }, 900)

    // Add event listener for the 'Yes' button to set countryRedirect to true in sessionStorage


    document.querySelectorAll('.yes-button').forEach(nobutton=>{
        nobutton.addEventListener('click', function (e) {
          e.preventDefault();
          sessionStorage.setItem('countryPopupShown', 'true');
          sessionStorage.setItem('countryRedirect', 'false');
          if (document.querySelector('.country-specific-popup-us')){
            document.querySelector('.country-specific-popup-us').style.display = 'none';
          }
      });
    });

});
